<template>
  <component
    :is="element"
    class="label-text-component"
    :class="[sizeClass]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'LabelText',
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    element() {
      return this.inline ? 'span' : 'p';
    },
    sizeClass() {
      return `size-${this.size}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-text-component {
  font-weight: $semi-bold;
  margin: 0;

  &.size-xs {
    font-size: rem-calc(12);
    line-height: rem-calc(16);
  }

  &.size-sm {
    font-size: rem-calc(14);
    line-height: rem-calc(16);
  }

  &.size-md {
    font-size: rem-calc(16);
    line-height: rem-calc(20);
  }

  &.size-lg {
    font-size: rem-calc(18);
    line-height: rem-calc(24);
  }
}
</style>
